import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'vex-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
})
export class SkeletonComponent implements OnInit {
  @Input() heigthTailwind: string;
  @Input() circle: boolean;

  constructor() {}

  ngOnInit(): void {}
}
